<template>
  <div class="join">
    <div class="header-box">
      <div class="admin">
        <img class="avatar" :src="deviceInfo.profilePicture" alt="">
        <div class="admin-info">
          <p class="name">{{deviceInfo.name}}</p>
          <p class="invite-text">邀请你加入TA的家庭</p>
        </div>
      </div>
    </div>
    <img class="banner" src="/images/family/join/join0.png" alt="">
    <div class="title">
      <img class="title-star" src="/images/family/join/join1.png" alt="">
      <img class="title-text" src="/images/family/join/join2.png" alt="">
    </div>
    <ul class="member-box">
      <li class="member" v-for="item in memberList" :key="item.id">
        <img class="member-icon" :src="item.profilePicture||'/images/member_default.png'" alt="">
        <span class="member-text">{{item.nickName}}</span>
      </li>
    </ul>
    <div class="footer">
      <button :class="['footer-btn', {'active': !isBind}]" @click="joinHandler" :disabled="isBind">{{examineStatus}}</button>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    isEmpty
  } from 'lodash';

  const devicePic={
    10007:'/images/family/join/1c.png'
  }

  export default {
    data() {
      return {
        appId: null,
        deviceId: null,
        isReady: false,
        isBind: false,
        deviceInfo: {
           profilePicture: devicePic[this.appId]||'/images/family/join/1c.png',
           name: '小智伴'
        },
        memberList: [],
        membersTotal: 0,
        examineStatus: "加入家庭,与宝宝共同成长"
      }
    },
    // 无deviceId, appId，无跳错误页
    beforeRouteEnter(to, from, next) {
      next(vm => {
        let {
          deviceId,
          appId
        } = vm.$route.query;
        if (!appId || !deviceId) {
          vm.$router.push({
            path: "/error/600"
          })
          return;
        }
        vm.appId = Number(appId);
        vm.deviceId = deviceId.trim();
        vm.isReady = true;
      })
    },
    created() {
      this.$toggleWechatShareItems(false);
    },
    watch: {
      isReady: {
        immediate: true,
        handler: function(isReady) {
          if (isReady) {
            this.getDeviceMembers();
            this.getdeviceInfo();
            this.getDeviceMemberstotal()
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        userInfo: 'auth/userInfo',
        uid: 'auth/uid',
        downloadPath: 'externalInterface/downloadApp',
      }),
      headers() {
        return {
          appId: this.appId,
          // deviceType: "mobile",
          deviceType: "robot",
          deviceId: this.deviceId
        }
      }
    },
    methods: {
      ...mapMutations({
        setToast: 'setToastShow',
        setLoading: 'setLoadingShow'
      }),
      getdeviceInfo(){
        this.$api.device_v1_info_sn_sn_get({
          headers: {
            deviceId: this.deviceId
          },
          path:{
            sn: this.deviceId
          }
        }).then(e=>{
          this.deviceInfo.name = e.name || '小智伴'
        })
      },
      getDeviceMembers(){
        this.$api.api_v3_device_info_members_deviceId_post({
           headers: {
            // appId: this.appId,
            deviceId: this.deviceId
          },
          path:{
            deviceId: this.deviceId
          }
        }).then(e => {
          // console.info(e,"设备成员信息")
          // 仅显示加入家庭成员信息，审核状态examine 1:通过
           this.memberList = e && e.content
        })
      },

      getDeviceMemberstotal(){
        this.$api.api_v3_device_info_members_total_deviceId_get({
          headers: {
            deviceId: this.deviceId
          },
          path:{
            deviceId: this.deviceId
          }
        }).then(e=>{
           this.checkBindStatus();
           if(e) this.membersTotal = e;
        }
        )
      },
      checkBindStatus() {
        this.$api.api_v3_device_info_search_exists_post({
          headers: {
            appId: this.appId,
            deviceId: this.deviceId
          },
          data: {
            ...this.headers,
            userUid: this.uid,
          }
        }).then(e => {
          // console.log(e, '根据条件查询绑定设备信息是否存在')
          //提交申请后审核状态为 0/1/2都为true
          this.isBind = e.code ? e.data : e;
          if (!this.isBind) {
            if(this.membersTotal >= 10){
              // 现有家庭成员已满10个（包含正在申请加入的用户），toast：当前家庭成员已满
              this.examineStatus = "当前家庭成员已满，期待您对宝宝的关心";
              this.isBind = true;
            }else{
              this.examineStatus = "加入家庭,与宝宝共同成长"
            }
            return;
          }
          this.getExamineStatus();
        })
      },
      async getExamineStatus() {
        let result = (i) => {
          return this.$api.api_v3_device_info_search_post({
            // header的当前用户的信息
            headers: {
              appId: this.appId,
            },
            data: {
              ...this.headers,
              userUid: this.uid,
              // 审核状态0:待审核 1:通过 2:不通过 不传默认为1
              examine: i
            }
          })
        }
        let flag = false;
        for (let i = 0; i <= 2; i++) {
          await result(i).then(e => {
            if (!e.code) {
              flag = true;
              // console.info(e, "根据条件查询绑定设备信息")
              // 审核状态0:待审核 1:通过 2:不通过
              switch (e.examine) {
                case 0:
                  this.examineStatus = "你已申请加入家庭，请耐心等待管理员审核";
                  this.isBind = true;
                  break
                case 1:
                  this.examineStatus = "你已经加入该家庭";
                  this.isBind = true;
                  this.$createDialog({
                    type: "confirm",
                    title: "你已经加入该家庭",
                    content: "是否打开智伴优学APP？",
                    confirmBtn: {
                      text: "打开",
                      active: true,
                      disabled: false,
                      href: this.downloadPath
                    },
                    cancelBtn: {
                      text: "再看看",
                      active: false,
                      disabled: false,
                      href: "javascript:;"
                    }
                  }).show();
                  break
                case 2:
                  this.examineStatus = "审核不通过，请重新申请";
                  this.isBind = false;
                  break
                default:
                  this.examineStatus = "加入家庭,与宝宝共同成长"
                  this.isBind = false;
                  break
              }
            }
          })
          if (flag === true) {
            break
          }
        }
      },
      joinHandler() {
        this.$api.api_v3_device_info_post({
          // header的当前用户的信息
          headers: {
            appId: this.appId,
          },
          //data是设备信息
          data: {
            deviceId: this.deviceId,
            deviceType: "robot"
          }
        }).then(e => {
          if (isEmpty(e)) return;
          this.$createDialog({
            type: "confirm",
            title: "申请加入成功",
            content: "是否打开智伴优学APP？",
            confirmBtn: {
              text: "打开",
              active: true,
              disabled: false,
              href: this.downloadPath
            },
            cancelBtn: {
              text: "再看看",
              active: false,
              disabled: false,
              href: "javascript:;"
            },
            onCancel: () => {
              window.location.reload()
            }
          }).show();
        })
      }
    }
  }
</script>
<style scoped>
  .join {
    width: 100vw;
    min-height: 100vh;
    background:#56B2FC;
  }

  .join .header-box {
    padding: 18px 16px;
    background:linear-gradient(180deg,rgba(117,193,254,1) 0%,rgba(102, 185, 254, 1) 100%);
  }

  .join .admin {
    height: 64px;
    background: rgba(0, 62, 163, 0.2);
    display: flex;
    border-radius: 8px;
    padding: 9px 0 9px 16px;
    color: #fff;
  }

  .admin .avatar {
    width: 46px;
    height: 46px;
    border: 2px solid rgba(255, 255, 255, 1);
    border-radius: 100%;
    margin-right: 8px;
  }

  .admin-info{
    display: flex;
    flex-wrap: wrap;
    flex-direction:row;
    justify-content: space-between;
  }

  .join .admin>p {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
  }

  .admin-info>p{
    display: block;
    width: 100%;
  }

  .admin-info .name {
    height: 25px;
    font-size: 18px;
    font-weight: bold;
    line-height: 25px;
  }

  .admin-inf .invite-text{
    height:20px;
    font-size:14px;
    color:rgba(255,255,255,1);
    line-height:20px;
  }

  .join .banner {
    display: block;
    width: 100vw;
  }

  .title {
    margin: 3px 0 12px 15px;
  }

  .title .title-star {
    width: 25px;
    margin-right: 5px;
  }

  .title .title-text {
    width: 73px;
  }

  .member-box {
    padding-left: 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .member-box .member {
    margin-right: 13px;
    margin-bottom: 10px;
    padding: 0 8px;
    height: 30px;
    background: rgba(0, 62, 163, 0.2);
    border-radius: 15px;
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .member .member-icon {
    display: block;
    width: 22px;
    height: 22px;
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 100%;
    margin-right: 2px;
  }

  .member .member-text {
    display: block;
    height: 15px;
    max-width: 78px;
    font-size:13px;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .footer {
    text-align: center;
    margin-top: 8px;
  }

  .footer-btn {
    width: 343px;
    height: 53px;
    background-image: url('/images/family/join/join4.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-color: inherit;
    font-size: 16px;
    line-height: 32px;
    font-weight: bold;
    color: #fff;
  }

  .footer-btn.active {
    background-image: url('/images/family/join/join3.png');
    background-repeat: no-repeat;
    background-color: inherit;
    color: #fff;
    color: rgba(124, 54, 28, 1);
  }
</style>